<template lang="pug">
  v-flex 
    v-card
      v-card-title Tipos de producto
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar tipo de producto' single-line hide-details)
        MassiveProductTypeDialog
        v-dialog(v-model='ProductType.dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
          v-card
            v-card-title Registro
            v-card-text
              v-text-field(v-model='data.descripcion' label='Nombre')
              v-text-field(v-model='data.codigo_producto_sunat' label='Código de Producto')
            v-card-actions
              v-spacer
              v-btn(color='primary'  @click='save()') Guardar
      v-data-table.elevation-1(:headers='headers' :items='productTypeRecord' :search='search')
        template(v-slot:item.action='{item}')
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nombre', value: 'descripcion' },
      { text: 'Codigo', value: 'codigo_producto_sunat' },
      {text:'', value:'action'}
    ],
    record: [],
  }),
  methods:{
    ...mapActions({
      editItem: 'ProductType/get',
      deleteItem: 'ProductType/clean',
      save: 'ProductType/add',
      clearForm: 'ProductType/clearForm',
    }),
  },
  computed:{
    ...mapGetters({
      productTypeRecord: 'ProductType/record',
    }),
    ...mapState({
      data: state=> state.ProductType.data,
      ProductType :state=> state.ProductType,
    })
  },
  components: {
    MassiveProductTypeDialog: ()=>import('.././components/MassiveProductTypeDialog')
  },
}
</script>
